import styled from 'styled-components';
import LikeSVG from '@catalogo/ui-americanas-desktop-svg/like-v2.svg';

interface IProps {
  $feedback?: boolean;
  isDesk?: boolean;
}

const TextMobile = styled.p`
  word-break: break-word;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #575757;
  padding-top: 6px;
`;

const TextDesk = styled.p`
  word-break: break-word;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #575757;
  padding-right: 15px;
`;

const Wrapper = styled.div<IProps>`
  display: flex;
  justify-content: ${({ isDesk }) => (isDesk ? 'flex-end' : 'space-between')};
  align-items: center;
  margin: ${({ isDesk }) => (isDesk ? '0 5px 0 0' : '10px 5px 0 0')};
`;

const LikeAndDislike = styled.div<IProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding-right: ${({ isDesk }) => (isDesk ? '16px' : '')};
`;

const WrapperButton = styled.div`
  display: flex;
  align-items: center;
`;

const LikeUI = styled(LikeSVG)<IProps>`
  width: ${({ isDesk }) => (isDesk ? '20px' : '18px')};
  cursor: pointer;
`;

const Like = styled(LikeUI)<IProps>`
  stroke: ${({ theme, $feedback }) => ($feedback ? '#369E26' : theme.grey.dark)};
  margin-bottom: 3px;
`;

const Dislike = styled(LikeUI)<IProps>`
  transform: rotate(180deg);
  stroke: ${({ theme, $feedback }) => ($feedback ? '#D71627' : theme.grey.dark)};
  margin-top: 4px;
`;

const Count = styled.span<IProps>`
  font-size: ${({ isDesk }) => (isDesk ? '14px' : '12px')};
  margin-left: 3px;
  color: ${({ theme }) => theme.textColor};
`;

export { Count, Dislike, Like, LikeAndDislike, LikeUI, WrapperButton, TextMobile, TextDesk, Wrapper };
